<!-- 

Good example here bar chart ---[ https://stackoverflow.com/questions/48726636/draw-d3-axis-without-direct-dom-manipulation 

-->

<template>
    <div>
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 1000 150"
            preserveAspectRatio="xMidYMid meet"
        >
            <g class="lineChart" v-bind:transform="translate">
                <axis
                    class="yA"
                    v-bind:scales="getScales().yAxis"
                    v-bind:chartDefaults="chartDefaults"
                    v-bind:data="data"
                    v-bind:trns="trnsY"
                />
                <!--axis
                    class="xA"
                    v-bind:scales="getScales().xAxis"
                    v-bind:chartDefaults="chartDefaults"
                    v-bind:data="data"
                    v-bind:trns="trnsX()"
                /-->
                <axis
                    class="grid"
                    v-bind:scales="getScales().yGrid"
                    v-bind:chartDefaults="chartDefaults"
                    v-bind:data="data"
                    v-bind:trns="trnsY"
                    v-bind:style="{ opacity: chartDefaults.gridOpacity }"
                />
                <path class="line" :d="line" />
                <path class="line2" :d="line2" />
            </g>
        </svg>
        <p class="text">{{ chartDefaults.title }}</p>
    </div>
</template>

<script>
import * as d3 from 'd3';
import Axis from './Axis';
export default {
    name: 'vue-line-chart',
    components: {
        axis: Axis, // Using reusable component to draw x,y axis and Grid.
    },
    props: {
        data: Array,
        index: Number,
    },
    data() {
        return {
            scale: undefined,
            chartDefaults: {
                width: 1000,
                height: 150,
                chartId: 'linechart-vue',
                _title: 'Altimetria',
                margin: {
                    top: 5,
                    right: 5,
                    bottom: 15,
                    left: 0,
                },
                gridOpacity: 1,
                data: [],
            },
            line: '',
            line2: '',
            //Translate co-ords for chart, x axis and yaxis. This is injected into template
            translate: 'translate(' + 50 + ',' + 5 + ')',
            trnsY: 'translate(0,0)',
            trnsX: this.getTrnsx,
            toggleClass: true,
        };
    },
    mounted() {
        var scale = {};
        //Kick off drawing chart once component is mounted

        this.calculatePath();
    },
    watch: {
        index(newVal) {
            //console.log(newVal);
            let sub = this.data.slice(0, newVal);

            const path2 = d3
                .area()
                .x((d) => {
                    return this.scale.x(d.index);
                })
                .y0((d) => {
                    return this.chartDefaults.height;
                })
                .y1((d) => {
                    return this.scale.y(d.meters);
                });
            //.curve(d3.curveCardinal);

            this.line2 = path2(sub);
        },
    },
    methods: {
        getScales() {
            // All the maths to work chart co ordinates and woring out Axis

            const x = d3
                .scaleLinear()
                .domain([
                    d3.min(this.data, function (d) {
                        return d.index;
                    }),
                    d3.max(this.data, function (d) {
                        return d.index;
                    }),
                ])
                .rangeRound([0, this.chartDefaults.width - 100]);
            const y = d3
                .scaleLinear()
                .domain([
                    d3.min(this.data, function (d) {
                        return d.meters - 20;
                    }),
                    d3.max(this.data, function (d) {
                        return d.meters + 20;
                    }),
                ])
                .range([this.chartDefaults.height, 0]);
            d3.axisBottom().scale(x);
            d3.axisLeft().scale(y);

            //Key funtions to draw X-axis,YAxis and the grid. All uses component axis
            //play around with time format to get it to display as you want : d3.timeFormat("%b-%d")
            var xAxis = d3
                .axisBottom()
                .scale(x)
                .tickFormat(d3.timeFormat(''))
                .tickValues(
                    this.data
                        .map(function (d, i) {
                            if (i > 0) {
                                return i;
                            }
                            return false;
                        })
                        .splice(1)
                )
                .ticks(4);

            var yAxis = d3.axisLeft().scale(y).ticks(5);
            var yGrid = d3
                .axisLeft()
                .scale(y)
                .tickSize(-(this.chartDefaults.width - 100), 0, 0)
                .tickFormat('');
            // Return the key calculations and functions to draw the chart
            return {
                x,
                y,
                xAxis,
                yAxis,
                yGrid,
            };
        },
        getTrnsx(chartDefaults) {
            //works out translate value in realtive to dynamic height
            const t = 'translate(0,' + this.chartDefaults.height + ')';
            return t;
        },
        calculatePath() {
            //Get key calculation funtions to draw chart , Ie scale, axis mapping and plotting
            this.scale = this.getScales();
            // Define calcultion to draw chart
            const path = d3
                .area()
                .x((d) => {
                    return this.scale.x(d.index);
                })
                .y0((d) => {
                    return this.chartDefaults.height;
                })
                .y1((d) => {
                    return this.scale.y(d.meters);
                });

            // draw line then this.line is injected into the template
            this.line = path(this.data);
        },
    },
};
</script>
<!-- css loaderhttps://vue-loader.vuejs.org/guide/scoped-css.html#mixing-local-and-global-styles -->
<style >
text {
    color: #fff;
}

path.line {
    fill: none;
    stroke: lightgray;
    stroke-width: 1px;
}

path.line2 {
    fill: #ff000077;
    stroke: lightgray;
    stroke-width: 1px;
}

.grid line {
    opacity: 0.5;
}
.xA line {
    opacity: 0.5;
}

/*Some fancy animation to draw chart*/
svg .lineChart2 > path {
    stroke: red;
    stroke-width: 3;
    stroke-dasharray: 4813.713;
    stroke-dashoffset: 4813.713;
    -webkit-animation-name: draw2;
    animation-name: draw2;
    -webkit-animation-duration: 10s;
    animation-duration: 10s;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
    -webkit-animation-timing-function: linear;
    animation-timing-function: linear;
}

.ani2 svg .lineChart2 > path {
    stroke: red;
    -webkit-animation-name: draw-2;
    animation-name: draw-2;
}
.ani1 svg .lineChart2 > path {
    stroke: blue;
    -webkit-animation-name: draw;
    animation-name: draw;
}
#Layer_1 {
    width: 100%;
}
@-webkit-keyframes draw {
    85% {
    }
    100% {
        stroke-dashoffset: 0;
    }
}
@keyframes draw {
    85% {
    }
    100% {
        stroke-dashoffset: 0;
    }
}

@-webkit-keyframes draw-2 {
    85% {
    }
    100% {
        stroke-dashoffset: 0;
    }
}

@keyframes draw-2 {
    85% {
    }
    100% {
        stroke-dashoffset: 0;
    }
}
.text {
    display: inline-block;
    font-size: 3vw;
    margin: 0.5vw 0 1.5vw;
}

svg {
    background-color: #00000000;
}
</style>